/**
 * Kontrakt `restrictions` — lista czynności ZABRONIONYCH pacjentowi przypisanemu do opaski.
 * Backend zwraca ją w GET-ach szczegółów pacjenta oraz w liście podopiecznych
 * (`/patient/myShortInfo`, `/patient/myShortInfoByCaregiver`); `[]` = brak blokad.
 *
 * Dwie zasady wynikające z kontraktu (uzgodnione z backendem 2026-08-12):
 * 1. Nieznane kody ignorujemy — kolejne restrykcje dojdą jako nowe wartości w tej samej
 *    tablicy, bez zmiany kształtu odpowiedzi.
 * 2. Zapis pojedynczy (`POST /manager/patient/{identifier}/restrictions`) ZASTĘPUJE całą
 *    listę, więc nową trzeba zbudować z aktualnej — inaczej skasowalibyśmy cudze blokady.
 */

export const RESTRICTION_EDIT_ALARM_PHONES = 'editAlarmPhones';

/** Czy pacjent może sam edytować numery alarmowe opaski. */
export function isAlarmPhonesEditAllowed(restrictions: string[] | null | undefined): boolean {
  return !(restrictions || []).includes(RESTRICTION_EDIT_ALARM_PHONES);
}

/** Lista do wysłania: zachowuje pozostałe restrykcje, także te nieznane frontowi. */
export function withAlarmPhonesEdit(
  restrictions: string[] | null | undefined,
  allowed: boolean,
): string[] {
  const others = (restrictions || []).filter(code => code !== RESTRICTION_EDIT_ALARM_PHONES);
  return allowed ? others : [...others, RESTRICTION_EDIT_ALARM_PHONES];
}
